module.exports = __webpack_public_path__ + "static/media/wood_cutter.aef3bfe5.png";